import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";

const MachinesModal = (props) => {
  let [name, setName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  const [validate, setValidate] = useState(false);
  let [status, setStatus] = useState("Active");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (props.data.machineCode) {
      setName(props?.data?.machineName);
      setId(props?.data?.machineCode);
      setStatus(props?.data?.status);
      setDeptCode(props?.data?.deptCode);
      setDeptName(props?.data?.deptName);
      setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
  ); // User Details from Store
  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deptList]);

  const deptResult =
    deptList &&
    deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));
  const handleSave = (event) => {
    const form = formRef.current;
    if (!deptCode) {
      setError(true);
      return;
    }
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const machineObj = {
        deptCode,
        deptName,
        machineName: name,
        machineCode: id,
        status: status,
      };
      if (edit) {
        machineObj._id = props.data._id;
      }
      props.onSave(machineObj, edit);
      setName("");
      setId("");
      setEdit(false);
    }
  };

  const handleCancel = (event) => {
    setName("");
    setId("");
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={edit ? t("msg_master_list.msg_machines.edit_page_title") : t("msg_master_list.msg_machines.page_title")}
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_machines.select_department")}
            </Form.Label>
            <DropdownListField
              required
              id="deptCode"
              name="deptName"
              className="dropdownHive w-full rounded-md"
              data={deptResult}
              value={deptCode}
              onChange={(value) => {setDeptCode(value?.deptCode);setDeptName(value?.deptName); setError(false);}}
              placeholder={t("msg_master_list.msg_machines.select_department")}
              autoFocus={true}
              error={error}
             disabled={!deptResult}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_machines.code")} :
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g: MAC-001"
              value={id || ""}
              onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_machines.machines_code_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_machines.machine_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={name || ""}
              onChange={(e) => setName(e.target.value)}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_machines.machines_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_common.status")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Active">{t("msg_common.active")}</option>
              <option value="Inactive">{t("msg_common.inactive")}</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MachinesModal;
